<template>
  <router-view />
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #000
  font-size 120%

p
  margin 60px

div
  display:  block;
  margin: 0vmin 0vmin 10% 0vmin;
  font-size:  5vmin;
</style>
